<template>
  <div class="details_content_all">
    <div class="details_content_repeat">
      <QS-h4-title title="支付计划信息" />
      <OperationSummary :summaryData="summaryData" :summary="payPlanSummary"  :loading="oLoading.search" />
      <div class="details_content_repeat_hundred">
        <!--bodyList 表格请求的数据-->
        <QS-common-table
          :loading="oLoading.search"
          :data="tableData"
          :columns="orderObj[orderType]?orderObj[orderType].tableColumns:tableColumns"
          :pagination="paginationData"
          @change="paginationChange"
        ></QS-common-table>
      </div>
      <SingleReceivable
        :title="orderObj[orderType] ? orderObj[orderType].title : '应收单预览'"
        :orderType="orderType"
        v-model="SingleReceivableShow"
        :params="currentRow"
      />
    </div>
  </div>
</template>

<script>
import { getDetailAccruedInfo } from '@/api/purchaseAndSaleAPI'
import { planList } from '@/api/purchaseAndSaleAPI/purchaseOrderApi'

import OperationSummary from '@/components/OperationSummary'
import SingleReceivable from './SingleReceivable'
import { afterChangeReceivableAmountTips, changeReceivableAmountTips, receivingPayments } from '@/config/txtConfig'
import { operateMaxShowLength } from '@/store/dict/config'

export default {
  name: 'PaymentPlan',
  components: {
    OperationSummary,
    SingleReceivable,
  },
  data() {
    return {
      currentRow: {},
      orderType: '',
      // eslint-disable-next-line vue/no-unused-properties
      mode: '',
      oLoading: {
        search: false,
        // eslint-disable-next-line vue/no-unused-properties
        submit: false,
      },
      paginationData: {
        pageSize: 10,
        pageNum: 1,
        total: 0,
        pageSizes: [10, 20, 30, 50],
      },
      orderObj: {
        purchaseSonOrder: {
          title: '应付单预览',
          tableColumns: [
            {
              name: 'modeName',
              columnProps: {
                prop: 'modeName',
                label: '支付内容',
              },
            },
            {
              name: 'sumCycle',
              columnProps: {
                prop: 'sumCycle',
                label: '应付总期数',
              },
            },
            {
              name: 'cycleDays',
              columnProps: {
                prop: 'cycleDays',
                label: '周期天数',
              },
            },
            {
              name: 'paymentAmount',
              columnProps: {
                prop: 'paymentAmount',
                label: '应付金额(元)',
              },
              getText: ({ row }) => this.numberWithCommas(row.paymentAmount),
            },
            {
              name: 'paidAmount',
              columnProps: {
                prop: 'paidAmount',
                label: '已付金额(元)',
              },
              getText: ({ row }) => this.numberWithCommas(row.paidAmount),
            },
            {
              name: 'surplusAmount',
              columnProps: {
                prop: 'surplusAmount',
                label: '剩余应付金额(元)',
                width: 140,
              },
              getText: ({ row }) => this.numberWithCommas(row.surplusAmount),
            },
            {
              name: 'remarks',
              columnProps: {
                prop: 'remarks',
                label: '备注',
              },
            },
            {
              name: 'operate',
              columnProps: {
                label: '操作',
                width: 240,
                fixed: 'right',
              },
              maxShowLength: operateMaxShowLength,
              type: 'operate',
              getOperateList: ({ row }) => {
                const arr = [
                  {
                    name: 'singleReceivable', label: '应付单详情', action: () => { this.singleReceivable(row) },
                  },
                ]
                return arr
              },
            },
          ],
          titleValueMap: {
            totalAmount: '计划总应收金额',
            afterChangeReceivableAmountSum: '变更后总应收金额',
            totalRentAmount: '租金',
            deposit: '押金',
            manageFee: '管理费',
            serviceFee: '其他服务费',
            surplusPaidAmount: '剩余应付金额',
          },
        },
      },
      // 订单收款
      tableColumns: [
        {
          name: 'modeName',
          columnProps: {
            prop: 'modeName',
            label: '支付内容',
          },
        },
        {
          name: 'sumCycle',
          columnProps: {
            prop: 'sumCycle',
            label: '应收总期数',
          },
        },
        {
          name: 'cycleDays',
          columnProps: {
            prop: 'cycleDays',
            label: '周期天数',
          },
        },
        {
          name: 'freeDays',
          columnProps: {
            prop: 'freeDays',
            label: '赠送天数',
          },
        },
        {
          name: 'receivableAmount',
          columnProps: {
            prop: 'receivableAmount',
            label: '计划应收金额(元)',
          },
          getText: ({ row }) => this.numberWithCommas(row.receivableAmount),
        },
        {
          name: 'changeReceivableAmount',
          columnProps: {
            prop: 'changeReceivableAmount',
            label: '变更金额(元)',
            width: 160,
          },
          columnHeaderTooltip: changeReceivableAmountTips,
          columnHeaderIcon: 'el-icon-question',
          getText: ({ row }) => {
            const txt = this.numberWithCommas(row.changeReceivableAmount)
            return parseInt(txt) > 0 ? `+${txt}` : txt
          },
        },
        {
          name: 'afterChangeReceivableAmount',
          columnProps: {
            prop: 'afterChangeReceivableAmount',
            label: '变更后应收金额(元)',
            width: 160,
          },
          columnHeaderTooltip: afterChangeReceivableAmountTips,
          columnHeaderIcon: 'el-icon-question',
          getText: ({ row }) => this.numberWithCommas(row.afterChangeReceivableAmount),
        },
        {
          name: 'receivedAmount',
          columnProps: {
            prop: 'receivedAmount',
            label: '已收金额(元)',
          },
          getText: ({ row }) => this.numberWithCommas(row.receivedAmount),
        },
        {
          name: 'receivingAmount',
          columnProps: {
            prop: 'receivingAmount',
            label: '收款中金额(元)',
            width: 140,
          },
          columnHeaderTooltip: receivingPayments,
          columnHeaderIcon: 'el-icon-question',
          getText: ({ row }) => this.numberWithCommas(row.receivingAmount),
        },
        {
          name: 'surplusAmount',
          columnProps: {
            prop: 'surplusAmount',
            label: '剩余应收金额(元)',
            width: 140,
          },
          getText: ({ row }) => this.numberWithCommas(row.surplusAmount),
        },
        {
          name: 'remarks',
          columnProps: {
            prop: 'remarks',
            label: '备注',
          },
        },
        {
          name: 'operate',
          columnProps: {
            label: '操作',
            width: 240,
            fixed: 'right',
          },
          maxShowLength: operateMaxShowLength,
          type: 'operate',
          getOperateList: ({ row }) => {
            const orderType = this.$route.query.orderType || 'personal'
            const arr = [
              {
                name: 'singleReceivable', label: orderType === 'purchaseSonOrder' ? '应付单详情' : '应收单详情', action: () => { this.singleReceivable(row) },
              },
            ]
            return arr
          },
        },
      ],
      // 收款假数据
      tableData: [],
      payPlanSummary: [],
      summaryData: [], // 统计时间
      SingleReceivableShow: false,
    }
  },
  created() {
    // 采购订单不展示赠送天数
    this.orderType = this.$route.query.orderType || 'personal'
  },
  mounted() {
    this.getPayPlanList()
  },
  methods: {
    // 应收单详情
    singleReceivable(row) {
      this.SingleReceivableShow = true
      this.currentRow = { ...row }
    },
    // 获取统计信息
    handlerSummary(value) {
      this.summaryData = []
      this.payPlanSummary = []
      let titleValueMap = {
        totalAmount: '计划总应收金额',
        afterChangeReceivableAmountSum: '变更后总应收金额',
        totalRent: '租金',
        deposit: '押金',
        manageFee: '管理费',
        serviceFee: '其他服务费',
        surplusReceiveAmount: '剩余应收金额',
      }
      titleValueMap = this.orderObj[this.orderType] ? this.orderObj[this.orderType].titleValueMap : titleValueMap
      // 日期
      const date = {
        startDate: '合同开始日期',
        endDate: '合同结束日期',
      }
      // 带单位天
      const days = {
        daysOfLease: '合同周期',
        presentDays: '赠送总天数',
      }
      // 时间范围
      const dateRange = {
        presentStartDate: '免租周期',
      }
      this.summaryData = [
        {
          subTitle: '合同开始日期',
          numbers: '--',
          code: 'startDate',
        },
        {
          subTitle: '合同结束日期',
          numbers: '--',
          code: 'endDate',
        },
        {
          subTitle: '合同周期',
          numbers: '--',
          code: 'daysOfLease',
        },
        {
          subTitle: '免租周期',
          numbers: '--',
          code: 'presentStartDate',
        },
        {
          subTitle: '赠送总天数',
          numbers: '--',
          code: 'presentDays',
        },
      ]
      Object.entries(value).forEach((item) => {
        if (titleValueMap[item[0]]) {
          this.payPlanSummary.push({
            key: item[0],
            subTitle: titleValueMap[item[0]],
            numbers: item[1],
            // eslint-disable-next-line no-mixed-operators
            period: (item[0] === 'totalRent' || item[0] === 'totalRentAmount') && value.periodNum || 0,
          })
        }

        if (date[item[0]]) {
          this.summaryData[this.summaryData.findIndex((i) => i.code === item[0])].numbers = item[1] ? item[1] : '--'
        }

        if (days[item[0]]) {
          this.summaryData[this.summaryData.findIndex((i) => i.code === item[0])].numbers = item[1] ? `${item[1]}天` : '--'
        }

        if (dateRange[item[0]]) {
          let freeCycle = ''
          if (value.presentStartDate && value.presentEntDate) {
            freeCycle = `${value.presentStartDate}至${value.presentEntDate}`
          } else {
            freeCycle = ''
          }
          this.summaryData[this.summaryData.findIndex((i) => i.code === item[0])].numbers = freeCycle
        }
      })
      // 变更后总应收金额 固定在第二索引位
      const resArr = []
      this.payPlanSummary.forEach((item) => (item.key === 'afterChangeReceivableAmountSum' ? resArr.splice(1, 0, item) : resArr.push(item)))
      this.payPlanSummary = resArr
      // 采购订单不显示
      if (this.$route.query.orderType === 'purchaseSonOrder') {
        const unShowInfo = ['免租周期', '赠送总天数']
        this.summaryData = this.summaryData.filter((item) => !unShowInfo.includes(item.subTitle))
      }
    },
    async getPayPlanList() {
      this.oLoading.search = true
      try {
        const apiObj = {
          purchaseSonOrder: planList,
        }
        const api = apiObj[this.$route.query.orderType] || getDetailAccruedInfo
        const id = Number(this.$route.query.id)
        const { code, data } = await api({
          ...this.paginationData,
          orderId: id,
        })
        this.oLoading.search = false
        if (code === 1) {
          this.paginationData.total = data.payPlanList.totalNum
          this.tableData = data.payPlanList.items
          this.tableData.forEach((item) => {
            if (!item.receivableState) {
              item.receivableState = 0
            }
          })
          this.handlerSummary(data)
        }
      } catch (error) {
        this.oLoading.search = false
      }
    },
    paginationChange(payload) {
      const { pagination } = payload
      this.paginationData.pageSize = pagination.pageSize
      this.paginationData.pageNum = pagination.pageNum
      this.getPayPlanList()
    },
  },
}
</script>

<style lang="scss" scoped>
</style>
